// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-searc-container:hover .icon-search-ico[data-v-0e97d6ca]:before{--text-opacity:1;color:#ef3524;color:rgba(239,53,36,var(--text-opacity))}.logo[data-v-0e97d6ca]:focus-visible{transition:none!important}.sticker-container[data-v-0e97d6ca]{align-items:center;top:0;left:0;right:auto;max-width:60px;width:60px;height:60px;max-height:60px}@media (min-width:992px){.sticker-container[data-v-0e97d6ca]{position:relative;top:auto;left:auto}}", ""]);
// Exports
module.exports = exports;
